import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { getLeads, getRepresentatives, uploadLeadsExcel } from "./leadsThunks";
import API_BASE_URL from "../../config";
import axios from "axios";

export const uploadQuizExcel = createAsyncThunk(
  "lawCollegeQuiz/uploadQuizExcel",
  async (
    { created_by, file, difficultyLevel, category },
    { rejectWithValue }
  ) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(
        `${API_BASE_URL}/quiz/admin/upload-quiz-questions-excel?level=${difficultyLevel}&id=${created_by}&law=${category}`,
        // `${API_new}/upload-quiz-questions-excel?level=${difficultyLevel}&id=${created_by}&law=${category}`,
        formData
      );

      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue("No questions found in the uploaded file.");
      }
    } catch (error) {
      console.error("Excel Upload Error:", error);
      return rejectWithValue(error.response?.data?.message || "Upload failed.");
    }
  }
);
// { level, created_by, filename, from_date, to_date, limit, offset },
export const viewErrorLogs = createAsyncThunk(
  "lawCollegeQuiz/viewErrorLogs",
  async ({ requestBody }, { rejectWithValue }) => {
    try {
      const body = requestBody || {};
      const response = await axios.post(
        `${API_BASE_URL}/quiz/admin/quiz-questions-upload-errors`,
        body
      );

      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(
          "No errors in questions found in the uploaded file."
        );
      }
    } catch (error) {
      console.error("Excel Upload Error:", error);
      return rejectWithValue(error.response?.data?.message || "Upload failed.");
    }
  }
);
export const addManualQuestion = createAsyncThunk(
  "lawCollegeQuiz/addManualQuestion",
  async (
    {
      created_by,
      question,
      correct_option,
      option_A,
      option_B,
      option_C,
      option_D,
      level,
      law,
    },
    { rejectWithValue }
  ) => {
    try {
      const body = {
        created_by,
        question,
        correct_option,
        option_A,
        option_B,
        option_C,
        option_D,
        level,
        law,
      };
      const response = await axios.post(
        `${API_BASE_URL}/quiz/admin/add-question`,
        body
      );

      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue("Question cnt b added.");
      }
    } catch (error) {
      const errorMsg = error.response?.data?.error;
      return rejectWithValue(errorMsg || "Upload failed.");
    }
  }
);
export const getQuizQuestions = createAsyncThunk(
  "lawCollegeQuiz/getQuizQuestions",
  async ({ body }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/quiz/admin/questions`,
        body
      );

      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue("No questions found in the uploaded file.");
      }
    } catch (error) {
      console.error("Excel Upload Error:", error);
      return rejectWithValue(error.response?.data?.message || "Upload failed.");
    }
  }
);

// 25 july
export const updateQuestion = createAsyncThunk(
  "lawCollegeQuiz/updateQuestion",
  async (
    { content, level, correct_option, updated_by, options, id },
    { rejectWithValue }
  ) => {
    try {
      const body = {
        content,
        level,
        correct_option,
        updated_by,
        options,
      };
      const response = await axios.put(
        `${API_BASE_URL}/quiz/admin/questions/${id}`,
        body
      );

      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue("Question cnt b updated.");
      }
    } catch (error) {
      console.error("Excel Upload Error:", error);
      return rejectWithValue(error.response?.data?.message || "Upload failed.");
    }
  }
);
export const deleteQuestion = createAsyncThunk(
  "lawCollegeQuiz/deleteQuestion",
  async ({ id, updated_by }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/quiz/admin/questions/${id}`,
        {
          data: { updated_by }, // ✅ pass body under `data`
        }
      );
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue("Question can't be deleted.");
      }
    } catch (error) {
      console.error("Delete Question Error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Deletion failed."
      );
    }
  }
);

// const API_new = "http://192.168.0.21:5007/api/quiz/admin/";
const laws_endpt = `${API_BASE_URL}/quiz/admin/laws`;
// get laws

export const getLaws = createAsyncThunk(
  "lawCollegeQuiz/getLaws",
  async (__, { rejectWithValue }) => {
    try {
      const response = await axios.get(laws_endpt);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue("No laws present.");
      }
    } catch (error) {
      console.error(error);
      return rejectWithValue(
        error.response?.data?.message || "retrieval failed."
      );
    }
  }
);
export const addLaw = createAsyncThunk(
  "lawCollegeQuiz/addLaw",
  async ({ name, description, created_by }, { rejectWithValue }) => {
    const body = { name, description, created_by };
    try {
      const response = await axios.post(laws_endpt, body);
      if (response.data) {
        alert("added category successfully");
        return response.data;
      } else {
        return rejectWithValue("Unable to create law.");
      }
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || "addition of law failed.");
      return rejectWithValue(
        error.response?.data?.message || "addition of law failed."
      );
    }
  }
);
export const updateLaw = createAsyncThunk(
  "lawCollegeQuiz/updateLaw",
  async ({ id, name, description, updated_by }, { rejectWithValue }) => {
    const body = { name, description, updated_by };
    try {
      const response = await axios.put(`${laws_endpt}/${id}`, body);
      if (response.data) {
        alert("updated category successfully");
        return response.data;
      } else {
        return rejectWithValue("Unable to create law.");
      }
    } catch (error) {
      console.error(error);
      return rejectWithValue(
        error.response?.data?.message || "addition of law failed."
      );
    }
  }
);
export const deleteCategory = createAsyncThunk(
  "lawCollegeQuiz/deleteCategory",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${laws_endpt}/${id}`);
      if (response.data) {
        alert("deleted category successfully");
        return response.data;
      } else {
        return rejectWithValue("Unable to create law.");
      }
    } catch (error) {
      console.error(error);
      return rejectWithValue(
        error.response?.data?.message || "deletion of law failed."
      );
    }
  }
);

const createAsyncCases = (builder, asyncThunk, key, stateKey = null) => {
  builder
    .addCase(asyncThunk.pending, (state) => {
      state[`${key}Status`] = "loading";
      state[`${key}Error`] = null; // reset error on new request
    })
    .addCase(asyncThunk.fulfilled, (state, action) => {
      state[`${key}Status`] = "succeeded";
      if (stateKey) state[stateKey] = action.payload;
    })
    .addCase(asyncThunk.rejected, (state, action) => {
      state[`${key}Status`] = "failed";
      state[`${key}Error`] = action.error?.message || "Something went wrong";
    });
};

const lawCollegeQuizSlice = createSlice({
  name: "law college",
  initialState: {
    difficultyLevels: [],
    questionsList: [],
    errorLogs: [],
    view_logs: false,
    searchTerm: "",
    loading: false,
    openPopUp: false,
    mode: "",
    newQuestionForm: {
      question: "",
      option_a: "",
      option_b: "",
      option_c: "",
      option_d: "",
      correct_option: "",
      difficulty_level: "",
    },
    questionForm: {
      questionId: "",
      question: "",
      option_a: "",
      option_b: "",
      option_c: "",
      option_d: "",
      correct_option: "",
      difficulty_level: "",
      created_by: "",
      updated_at: "",
      created_by_user_id: "",
      updated_at_user_id: "",
      created_at: "",
    },
    offset: "",
    //for the laws
    categories: [],
    selectedCategory: "",
    updatedCategory: "",
    newCategory: "",
    newCategoryDescriptn: "",
    option: "",

    //for the upload excel file
    uploadStatus: "idle",
    uploadError: null,
  },
  reducers: {
    setState: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    setNewQuestionForm: (state, action) => {
      const { key, value } = action.payload;
      state.newQuestionForm[key] = value;
    },
    setQuestionForm: (state, action) => {
      if (action.payload.key) {
        // handle single field update
        state.questionForm[action.payload.key] = action.payload.value;
      } else {
        // handle full object (like on initial edit/view load)
        state.questionForm = {
          ...state.questionForm,
          ...action.payload,
        };
      }
    },
    resetQuestionForm: (state) => {
      state.questionForm = {
        question: "",
        option_a: "",
        option_b: "",
        option_c: "",
        option_d: "",
        correct_option: "",
        difficulty_level: "",
      };
    },
    resetNewQuestionForm: (state) => {
      state.newQuestionForm = {
        question: "",
        option_a: "",
        option_b: "",
        option_c: "",
        option_d: "",
        correct_option: "",
        difficulty_level: "",
      };
    },
  },
  extraReducers: (builder) => {
    // for uploadQuizExcel
    builder
      .addCase(uploadQuizExcel.pending, (state) => {
        state.uploadStatus = "loading";
        state.uploadError = null;
      })
      .addCase(uploadQuizExcel.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.questions = action.payload;
      })
      .addCase(uploadQuizExcel.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.uploadError = action.payload;
      });
    // for addManualQuestion
    builder
      .addCase(addManualQuestion.pending, (state) => {
        state.uploadStatus = "loading";
        state.uploadError = null;
      })
      .addCase(addManualQuestion.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.questions = action.payload;
      })
      .addCase(addManualQuestion.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.uploadError = action.payload;
      });
    builder
      .addCase(getQuizQuestions.fulfilled, (state, action) => {
        state.questionsList = action.payload || {
          questions: [],
          offset: 0,
          limit: 100,
        };
      })
      .addCase(getQuizQuestions.rejected, (state) => {
        state.questionsList = { questions: [], offset: 0, limit: 100 };
      });
    builder
      .addCase(viewErrorLogs.fulfilled, (state, action) => {
        state.errorLogs = action.payload || {
          errors: [],
          offset: 0,
          limit: 100,
        };
      })
      .addCase(viewErrorLogs.rejected, (state) => {
        state.errorLogs = { errors: [], offset: 0, limit: 100 };
      });

    //for laws
    builder
      .addCase(getLaws.fulfilled, (state, action) => {
        state.categories = action.payload || [];
      })
      .addCase(getLaws.rejected, (state) => {
        state.categories = [];
      });
  },
});
export const {
  setState,
  resetNewQuestionForm,
  setNewQuestionForm,
  setQuestionForm,
  resetQuestionForm,
} = lawCollegeQuizSlice.actions;

export default lawCollegeQuizSlice.reducer;
